module.exports = __webpack_public_path__ + "static/media/mobileDataTile.e97baddf.svg";